import { Controller } from "@hotwired/stimulus"

// Tiny inline-confirm dialog controller.
//
// Markup pattern:
//   <div data-controller="dialog">
//     <button type="button" data-action="dialog#open">Disable</button>
//     <dialog data-dialog-target="dialog">
//       <form method="dialog">…</form>     <!-- Cancel -->
//       <%= form_with(... do |f| %>… submit ...<% end) %>
//     </dialog>
//   </div>
//
// The submit form is a regular Rails form whose action/method matches the
// existing button_to path — so the server contract is unchanged.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    event.preventDefault()
    if (typeof this.dialogTarget.showModal === "function") {
      this.dialogTarget.showModal()
    } else {
      // Fallback for browsers without <dialog>: just open inline.
      this.dialogTarget.setAttribute("open", "")
    }
    // Move focus to the first focusable control inside the dialog.
    const focusable = this.dialogTarget.querySelector(
      "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"
    )
    if (focusable) focusable.focus()
  }

  close(event) {
    if (event) event.preventDefault()
    if (typeof this.dialogTarget.close === "function") {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }
}
